/**
* @name APP u-faculty
* @autor vignesh.somayaji@u-planner.com
* @description
* Descripcion del controlador
* @controller 
* # name: customChartController
* # alias: autoCtrl
*/

export default class reflexionesportafolioController {

    constructor($scope, $state, $stateParams, ngNotify, $timeout, UserInfoConstant, ReviewSrv,$cookies,$mdDialog) {
        this.$scope = $scope;
        this.$state = $state;
        this.$timeout = $timeout;
        this.ngNotify = ngNotify;
        this.$stateParams = $stateParams;
        this.ReviewSrv = ReviewSrv
        this.userinfo = null;
        this.$mdDialog=$mdDialog;
        this.$scope.UserInfoConstant = UserInfoConstant
        this.$scope.$watch('UserInfoConstant[0].details[0]', (details, before) => {
            if (details !== undefined) {
                this.userinfo = details.user;
                this.teacherId  = this.$stateParams.teacherId
                this.cookiesUser = $cookies.get('currentUser') ? JSON.parse($cookies.get('currentUser')) : false
                this.param={'id_teacher':this.teacherId,
                            'id_work_plan':this.workplanId}
                this.main();
            }
        });

    }

    main() {
        console.log('Estoy en el controlador de reflexionesportafolioController')
        this.autoevaluation();

    }

    autoevaluation(){

        
        var THIS=this
        this.ReviewSrv.getReflectionMethod.get(this.param).$promise.then((dataReturn) => { 
        if (dataReturn.status === true) {

            THIS.reflextionData=dataReturn.data

        
        } else {
            console.log(dataReturn)
        }
      })
    }

    showMultivideoDialog (details) {

            this.videoLinks=details

            var confirm = this.$mdDialog.confirm({
            controller   : 'reflexionesDePortafolioEvidenciasController',
            controllerAs : 'reflexionesDePortafolioEvidencias',
            template     : require('../dialogs/reflexionesDePortafolioEvidencias.html'),
            locals       : {videoLinks:details},
            animation    : true,
            parent       : angular.element(document.body),
            clickOutsideToClose : true
            })

            this.$mdDialog.show(confirm).then(function(){

            })

       

         
    }


}

reflexionesportafolioController.$inject = ['$scope', '$state', '$stateParams', 'ngNotify', '$timeout', 'UserInfoConstant','ReviewSrv','$cookies','$mdDialog'];


// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/partials/review/summary/evaluacionDeProfesoresTemplates/controller/reflexionesportafolioController.js